export enum CdColor {
  YELLOW = "#fbc800",
  RIVER = "#1e5f6e",
  RED = "#fa2027",
  BLACK = "#181818",
  WHITE = "#FFFFFF",
  SKY = "#2996D2",
  SEA = "#2064b4"
}
